export const faqList = [
  {
    title: "What services does Techni Trust Technical Services offer?",
    content:
      "Techni Trust provides a wide range of services, including electrical and electromechanical works, plumbing, HVAC installation and maintenance, painting, flooring, waterproofing, and smart home automation."
  },
  {
    title:
      "Do you offer maintenance services for residential and commercial properties?",
    content:
      "Yes, we provide expert maintenance solutions for both residential and commercial properties, ensuring your systems and spaces stay functional, safe, and efficient"
  },
  {
    title: "How can I book a service with Techni Trust Technical Services?",
    content:
      "You can book a service by contacting us directly via phone or email. Our team will assist you in scheduling a visit and providing tailored solutions."
  },
  {
    title: "Are your services available across the UAE?",
    content:
      "Yes, Techni Trust Technical Services operates throughout the UAE, offering reliable solutions for homes, offices, and industrial spaces."
  },
  {
    title:
      "What makes Techni Trust different from other technical service providers?",
    content:
      "At Techni Trust, we focus on quality, efficiency, and customer satisfaction. With experienced professionals, innovative solutions, and affordable pricing, we deliver trusted care for every space."
  },
  {
    title: "Do you provide customized solutions for specific projects?",
    content:
      "Yes, we offer tailored solutions to meet the unique requirements of each project, ensuring customer satisfaction and highquality results."
  },
  {
    title: " What safety measures does Techni Trust follow during work?",
    content:
      "We prioritize safety by following strict industry standards and using advanced tools and techniques to ensure the wellbeing of our team, clients, and properties."
  }
];
